import { Button } from "@/components/ui/button"

const BULLETS = [
  "Paste a listing URL and we handle the rest",
  "Professional video ads in under 5 minutes",
  "Publish to every social channel at once",
]

export default function WelcomeStep({
  userName,
  onNext,
}: {
  userName: string
  onNext: () => void
}) {
  return (
    <div className="text-center">
      <h1 className="font-display text-4xl font-semibold tracking-tight text-charcoal sm:text-5xl">
        Welcome, {userName.split(" ")[0]}
      </h1>
      <p className="mx-auto mt-4 max-w-md text-lg text-warm-grey">
        Let&apos;s get your account set up. This takes less than two minutes.
      </p>

      <div className="mx-auto mt-10 max-w-sm space-y-4">
        {BULLETS.map((text, i) => (
          <div
            key={text}
            className="flex items-center gap-4 rounded-xl border border-stone/40 bg-white px-5 py-4 text-left opacity-0 animate-fade-in-up"
            style={{ animationDelay: `${300 + i * 200}ms`, animationFillMode: "forwards" }}
          >
            <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-red/10 text-sm font-semibold text-red">
              {i + 1}
            </span>
            <span className="text-sm font-medium text-charcoal">{text}</span>
          </div>
        ))}
      </div>

      <Button
        onClick={onNext}
        className="mt-10 bg-red px-10 py-5 text-sm font-semibold text-white hover:bg-red-deep opacity-0 animate-fade-in-up"
        style={{ animationDelay: "1000ms", animationFillMode: "forwards" }}
      >
        Let&apos;s go
      </Button>
    </div>
  )
}
